export enum MATCH_DATES_STATUS {
  ACTIVE = "ACTIVE",
  CLOSED = "CLOSED",
  UPCOMING = "UPCOMING",
  ARCHIVED = "ARCHIVED",
  MATCHING = "MATCHING"
}

export interface IMatchDatesStatusContext {
  status: string | undefined;
}
